import React, { useMemo } from 'react';
import xss from 'xss';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import { TRANSLATIONS } from '../__translations__';
import { SESSION_EXTENDED_MESSAGE_AUTO_HIDE_DURATION } from '../../constants';
import { getLocale, getSessionLifespan } from '../../utils';
import * as S from './styles';
export const SessionExtendedMessage = ({ open, anchorOrigin, onClose, }) => {
    const sessionLifespan = getSessionLifespan();
    const message = useMemo(() => {
        var _a;
        const translation = (_a = TRANSLATIONS[getLocale()]) !== null && _a !== void 0 ? _a : TRANSLATIONS.en;
        return (React.createElement(S.SessionExtendedSnackbarContentMessage, null,
            React.createElement(CheckIcon, null),
            React.createElement(Typography, { dangerouslySetInnerHTML: {
                    __html: xss(translation.sessionExtended(sessionLifespan)),
                } })));
    }, [sessionLifespan]);
    return (React.createElement(S.Snackbar, { open: open, autoHideDuration: SESSION_EXTENDED_MESSAGE_AUTO_HIDE_DURATION, anchorOrigin: anchorOrigin, onClose: onClose, message: message }));
};
//# sourceMappingURL=SessionExtendedMessage.js.map